<div class="container">
    <ui-v2-selector [options]="selectWebhooksSig()"
                    [multi]="false"
                    searchProperty="name"
                    valueProperty="_id"
                    [placeholder]="selectIsLoadingSig() ? ('FLOW_CHART.LOADING_WEBHOOKS'|translate) : ('WEBHOOK_DIALOG.PLACEHOLDERS.SELECT'|translate)"
                    [formControl]="webhookId"
                    [createBtnText]="'WORKFLOW_WEBHOOK.CREATE_BTN'"
                    [manageBtnText]="'WORKFLOW_WEBHOOK.MANAGE_BTN'"
                    (onCreateBtnClick)="create()"
                    (onManageBtnBtnClick)="manage()"
                    [required]="true"
                    [hasHeightClass]="true"
                    [disabledOptionsMap]="disabledWebhooksMap()"
                    [tooltipForDisableoption]="'WORKFLOW_WEBHOOK.DISABLEP_OPTION_TOOLTIP'|translate">
    </ui-v2-selector>
</div>